import React              from 'react';
import { reduxForm }      from 'redux-form';
import { useTranslation } from 'react-i18next';

import RenderButton        from '../../../components/buttons/base/RenderButton';
import { RenderTextField } from '../../../components/fields/redux/RenderTextField';

function VerificationForm({ ...props }) {
  const {
          form,
          handleSubmit,
          submitForm,
        }     = props;
  const { t } = useTranslation();

  return (
    <form
      name={form}
      className={form}
      noValidate={true}
      method={'post'}
      onSubmit={event => submitForm(event, handleSubmit)}
    >
      <RenderTextField
        name={'code'}
        label={t('client_numberOfOrder')}
      />
      <RenderButton type={'submit'} className={'fill'} label={t('btn_send')} />
    </form>
  );
}

export default reduxForm({
  form:         'VerificationForm',
  validate:     () => {
  },
  onSubmitFail: (errors, dispatch) => {
  },
})(VerificationForm);